module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Hidden_Heritage2#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "fp para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Hidden Heritage")]), _vm._v(" is dedicated to the memory of my beloved husband, Don Hinger. His wisdom, love, and integrity inspired and sustained me throughout our long marriage. ")]), _vm._v(" "), _c('p', {
    staticClass: "body para-style-override-4"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2b2bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hidden_Heritage-3.vue
// module id = 69
// module chunks = 0